import { navigation } from '@temperworks/components'
import { useCountryStore } from '../store/country'

export default defineNuxtPlugin((nuxtApp) => {
  const countryStore = useCountryStore()
  nuxtApp.vueApp.use(navigation, { router: nuxtApp.$router, backend: countryStore.backend })
})
